import { MediaPickerContainerProps, MediaPickerProps, ProcessingState } from './Types'
import { MediaPickerProvider, useMediaPickerContext } from './MediaPickerContext'
import { ChooseMedia } from './ChooseMedia/ChooseMedia'
import { ProcessingMedia } from './ProcessingMedia/ProcessingMedia'
import { useMemo } from 'react'

const MediaPicker = (props: MediaPickerProps) => {
  const { multiSelect, ...rest } = props
  const { processingFiles } = useMediaPickerContext()

  const processingFile = useMemo(() => {
    if (multiSelect) {
      return processingFiles.find((f) => f.processingState !== ProcessingState.Complete)
    }
    return processingFiles.length > 0 ? processingFiles[0] : null
  }, [multiSelect, processingFiles])

  return (
    <>
      {!processingFile && <ChooseMedia {...rest} />}
      {processingFile && (
        <ProcessingMedia selectedMedia={processingFile.file} processingState={processingFile.processingState} />
      )}
    </>
  )
}

const MediaPickerContainer = (props: MediaPickerContainerProps) => {
  const { selectedFiles = [], onSelect, skipBackgroundRemoval, ...rest } = props

  return (
    <MediaPickerProvider
      selectedFiles={selectedFiles}
      onSelect={onSelect}
      skipBackgroundRemoval={skipBackgroundRemoval}
    >
      <MediaPicker {...rest} />
    </MediaPickerProvider>
  )
}

export { MediaPickerContainer as MediaPicker }
